import { SelectOption } from '@fleet-beat/core';

export enum UserRole {
  Driver = 'driver',
  CoDriver = 'co-driver',
  LowFleetManager = 'low-fm',
  RegularFleetManager = 'regular-fm',
  HighFleetManager = 'high-fm',
  Admin = 'admin',
}

export const UserRoles: SelectOption[] = [
  { value: UserRole.Driver, label: 'Driver' },
  { value: UserRole.CoDriver, label: 'CoDriver' },
  { value: UserRole.LowFleetManager, label: 'Low Dispatcher' },
  { value: UserRole.RegularFleetManager, label: 'Dispatcher' },
  { value: UserRole.HighFleetManager, label: 'Super Dispatcher' },
  { value: UserRole.Admin, label: 'Admin' },
];

export const UserRolesAdapted: SelectOption[] = [
  { value: UserRole.Driver, label: 'Driver' },
  { value: UserRole.CoDriver, label: 'CoDriver' },
  { value: UserRole.LowFleetManager, label: 'Low Dispatcher' },
  { value: UserRole.RegularFleetManager, label: 'Dispatcher' },
  { value: UserRole.HighFleetManager, label: 'Super Dispatcher' },
  { value: UserRole.Admin, label: 'Admin' },
];

export const ManagerRoles: SelectOption[] = [
  { value: UserRole.LowFleetManager, label: 'Low Dispatcher' },
  { value: UserRole.RegularFleetManager, label: 'Dispatcher' },
  { value: UserRole.HighFleetManager, label: 'Super Dispatcher' },
];

export const DriverRoles: SelectOption[] = [
  { value: UserRole.Driver, label: 'Driver' },
  { value: UserRole.CoDriver, label: 'CoDriver' },
];
